import { Component, OnInit, AfterViewInit, OnDestroy, ViewChild, ElementRef, Renderer2, ChangeDetectorRef } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { CmsService, OccEndpointsService } from "@spartacus/core";
import { SharedService } from "../../services/shared.service";
import { DataLayerService } from "../../services/data-layer.service";

@Component({
  selector: 'app-personalization-banner',
  templateUrl: './personalization-banner.component.html',
  styleUrls: ['./personalization-banner.component.scss']
})
export class PersonalizationBannerComponent implements OnInit, AfterViewInit, OnDestroy{
  @ViewChild('banner') banner: ElementRef;
  bannerUrl: any;
  modalSubscription: any;
  popupSubscription: any;
  compUId: any;
  cmsResponse: any;

  constructor(
    private cmsData: CmsService,
    private occEndPoint: OccEndpointsService,
    private renderer: Renderer2,
    private activeModal: NgbActiveModal,
    private readonly cd: ChangeDetectorRef,
    private readonly sharedService: SharedService,
    private _dataService: DataLayerService
  ) { }
  mediaObj:any;
  ngOnInit(): void {
    this.modalSubscription = this.cmsData.getContentSlot('SanofiModelWindowSlot').subscribe((res) => {
     if(res) {
      this.compUId =  res.components[0].uid;
      this.popupSubscription = this.cmsData.getComponentData(res.components[0].uid).subscribe((res:any) => {
        if(res) {
          this.cmsResponse = res;
          this.mediaObj = res.media.widescreen;
          this.bannerUrl = res;
          this._dataService.addtoDataLayer("view_promotion", this.cmsResponse);
          this.cd.detectChanges();
      }
      });
     }
     });
   
  }
  ngAfterViewInit(): void {
    this.renderer.setStyle(this.banner.nativeElement, 'background', 
    `url(${this.occEndPoint.getBaseUrl({ baseUrl: true, prefix: false, baseSite: false })}${this.mediaObj?.url}) center/contain no-repeat content-box`);
  }

  ngOnDestroy(): void {
    this.bannerUrl = '';
    this.popupSubscription.unsubscribe();
    this.modalSubscription.unsubscribe();
  }
  
  closeModal(){
    this.activeModal.dismiss(this.compUId);
  }

  gtmSelectPromotion() {
    this._dataService.addtoDataLayer("select_promotion", this.cmsResponse);
  }

}
